import { faEllipsisV } from "@fortawesome/pro-regular-svg-icons/faEllipsisV";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconEllipsisV: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faEllipsisV} />;
};
